import { render } from "./hrm-regularization-create-modal.vue?vue&type=template&id=f6a22bbe&scoped=true"
import script from "./hrm-regularization-create-modal.vue?vue&type=script&lang=js"
export * from "./hrm-regularization-create-modal.vue?vue&type=script&lang=js"

import "./hrm-regularization-create-modal.vue?vue&type=style&index=0&id=f6a22bbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a22bbe"]])

export default __exports__